const footerResources = {
  en: {
    translation: {
      'Footer slogan': 'One app - many possibilities!',
      'Footer slogan2': 'The Alatau City Bank app has everything you need',
      'Footer link1': 'Company Info',
      'Footer link2': 'Licences',
      'Footer link3': 'Products',
      'Footer link4': 'Rules',
      'Footer link5': 'For agents',
      'Footer link6': 'Rates',
      'Footer link7': 'Partners',
      'Footer link8': 'Contacts',
      'Footer link9': 'News',
      'FooterBank title': 'Bank',
      'FooterBank link1': 'Bonus program',
      'FooterBank link2': 'Online loan',
      'FooterBank link3': 'Refinancing',
      'FooterBank link4': 'Alatau City Deposit Account',
      'FooterBank link5': 'Alatau City card',
      'FooterBank link6': 'Other products',
      'FooterBank link7': 'Salary project',
      'FooterBank link8': 'Cooperation with Private bailiffs',
      'FooterBusiness title': 'For Business',
      'FooterBusiness link1': 'Alatau City Tole and acquiring',
      'FooterBusiness link2': 'Business loan',
      'FooterBusiness link3': 'Open an account',
      'FooterBusiness link4': 'Other services',
      'FooterShop title': 'Shop',
      'FooterShop link1': 'Products',
      'FooterShop link2': 'Services',
      'FooterShop link3': 'Food products',
      'FooterShop link4': 'Promotions',
      'FooterShop link5': 'Become a partner',
      'FooterInsurance title': 'Insurance',
      'FooterInsurance link1': 'Vehicle insurance',
      'FooterInsurance link2': 'Travel insurance',
      'FooterInsurance link3': 'Property insurance',
      'FooterInsurance link4': 'Health insurance',
      'FooterInsurance link5': 'All products',
      'FooterInvestments title': 'Investments',
      'FooterInvestments link1': 'IPO of national companies',
      'FooterInvestments link2': 'Online trading',
      'FooterInvestments link3': 'Investment funds (UIF)',
      'FooterInvestments link4': 'Investment Academy',
      'FooterInvestments link5': 'Retirement assets',
      'FooterInvestments link6': 'Social network of investors',
      'FooterInvestments link7': 'Other products',
      FooterCopyright: 'JSC "Insurance Company "Alatau City Garant"',
      'FooterPrivacy policy': 'Privacy policy',
      allNews: 'All news',
      FooterFraudtext:
        'Report corruption or fraud \n+7 (727) 356 25 25 ("5" in tone mode)',
    },
  },
  kz: {
    translation: {
      'Footer slogan': 'Бір қосымша – мол мүмкіндіктер!',
      'Footer slogan2':
        'Alatau City Bank қосымшасынан Сіздер өзіңізге керектінің бәрін табасыз ',
      'Footer link1': 'Компания туралы',
      'Footer link2': 'Лицензиялар',
      'Footer link3': 'Өнімдер',
      'Footer link4': 'Ережелер',
      'Footer link5': 'Агенттерге',
      'Footer link6': 'Тарифтер',
      'Footer link7': 'Серіктестер',
      'Footer link8': 'Байланыстар',
      'Footer link9': 'Жаңалықтар',
      'FooterBank title': 'Банк',
      'FooterBank link1': 'Бонустық бағдарлама',
      'FooterBank link2': 'Бонустық бағдарлама',
      'FooterBank link3': 'Қайта қаржыландыру',
      'FooterBank link4': 'Alatau City депозиті',
      'FooterBank link5': 'Alatau City картасы',
      'FooterBank link6': 'Басқа өнімдер',
      'FooterBank link7': 'Жалақы жобасы',
      'FooterBank link8': 'ЖСОмен ынтымақтастық',
      'FooterBusiness title': 'Бизнес үшін',
      'FooterBusiness link1': 'Alatau City Tole және эквайринг',
      'FooterBusiness link2': 'Бизнеске арналған кредит',
      'FooterBusiness link3': 'Шот ашу',
      'FooterBusiness link4': 'Басқа қызметтер',
      'FooterShop title': 'Дүкен',
      'FooterShop link1': 'Тауарлар',
      'FooterShop link2': 'Қызметтер',
      'FooterShop link3': 'Азық-түлік',
      'FooterShop link4': 'Акциялар',
      'FooterShop link5': 'Серіктес болу',
      'FooterInsurance title': 'Сақтандыру',
      'FooterInsurance link1': 'Автосақтандыру',
      'FooterInsurance link2': 'Саяхаттау',
      'FooterInsurance link3': 'Мүлік',
      'FooterInsurance link4': 'Денсаулық',
      'FooterInsurance link5': 'Басқа қызметтер',
      'FooterInvestments title': 'Инвестициялар',
      'FooterInvestments link1': 'Ұлттық компаниялардың IPO',
      'FooterInvestments link2': 'Онлайн сауда',
      'FooterInvestments link3': 'Инвестициялық қорлар (ИПҚ)',
      'FooterInvestments link4': 'Инвестициялау академиясы',
      'FooterInvestments link5': 'Зейнетақы активтері',
      'FooterInvestments link6': 'Әлеуметтік инвесторлар желісі',
      'FooterInvestments link7': 'Басқа өнімдер',
      FooterCopyright: '«Alatau City Garant» сақтандыру компаниясы»',
      'FooterPrivacy policy': 'Құпиялылық саясаты',
      allNews: 'Барлық жаңалықтарға',
      FooterFraudtext:
        'Сыбайлас жемқорлық немесе алаяқтық туралы хабарлау \n+7 (727) 356 25 25 ("5" тон режимінде)',
    },
  },
  ru: {
    translation: {
      'Footer slogan': 'Одно приложение – много возможностей!',
      'Footer slogan2':
        'В приложении Alatau City Bank вы найдете все, что вам нужно',
      'Footer link1': 'О компании',
      'Footer link2': 'Лицензии',
      'Footer link3': 'Продукты',
      'Footer link4': 'Правила',
      'Footer link5': 'Агентам',
      'Footer link6': 'Тарифы',
      'Footer link7': 'Партнеры',
      'Footer link8': 'Контакты',
      'Footer link9': 'Новости',
      'FooterBank title': 'Банк',
      'FooterBank link1': 'Бонусная программа',
      'FooterBank link2': 'Онлайн-кредит',
      'FooterBank link3': 'Рефинансирование',
      'FooterBank link4': 'Alatau City депозит',
      'FooterBank link5': 'Карта Alatau City',
      'FooterBank link6': 'Прочие продукты',
      'FooterBank link7': 'Зарплатный проект',
      'FooterBank link8': 'Сотрудничество с ЧСИ',
      'FooterBusiness title': 'Бизнес',
      'FooterBusiness link1': 'Alatau City Tole и эквайринг',
      'FooterBusiness link2': 'Кредит для бизнеса',
      'FooterBusiness link3': 'Открыть счет',
      'FooterBusiness link4': 'Прочие услуги',
      'FooterShop title': 'Магазин',
      'FooterShop link1': 'Товары',
      'FooterShop link2': 'Услуги',
      'FooterShop link3': 'Продукты',
      'FooterShop link4': 'Акции',
      'FooterShop link5': 'Стать партнером',
      'FooterInsurance title': 'Страхование',
      'FooterInsurance link1': 'Автострахование',
      'FooterInsurance link2': 'Путешествия',
      'FooterInsurance link3': 'Имущества',
      'FooterInsurance link4': 'Здоровье',
      'FooterInsurance link5': 'Все продукты',
      'FooterInvestments title': 'Инвестиции',
      'FooterInvestments link1': 'IPO нацкомпаний',
      'FooterInvestments link2': 'Онлайн торговля',
      'FooterInvestments link3': 'Инвестиционные фонды (ПИФ)',
      'FooterInvestments link4': 'Академия инвестирования',
      'FooterInvestments link5': 'Пенсионные активы',
      'FooterInvestments link6': 'Соцсеть инвесторов',
      'FooterInvestments link7': 'Прочие продукты',
      FooterCopyright: 'АО «Страховая компания «Alatau City Garant»',
      'FooterPrivacy policy': 'Политика конфиденциальности',
      allNews: 'Ко всем новостям',
      FooterFraudtext:
        'Сообщить о коррупции или мошенничестве \n+7 (727) 356 25 25 ("5" в тоновом режиме)',
    },
  },
};

export default footerResources;
